import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { Session } from 'src/app/models/session';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private session: Session,private router: Router, private toastr: ToastrService,private service: UserService) { }

  email = "";
  password = "";
  showResetDialog = false;

  showPassword = false;

  ngOnInit() {
    this.session.user = null;
    localStorage.removeItem("user");
  }

  login(){
    this.service.login(this.email,this.password).subscribe(d=>{
      this.session.user = { name: d.body.nombre + " " + d.body.apellido,email: d.body.email , token: d.headers.get("X-Auth-Token") };
      localStorage.setItem("user", JSON.stringify(this.session.user));
      this.router.navigate(['']);
    }, er =>{
      
      this.toastr.error('Email or Password not found','Login failed');
    });
    
  }

  login2(){
    this.session.user = { name: "Guillermo Garnica", token:"tokenDePrueba"};
    localStorage.setItem("user", JSON.stringify(this.session.user));
    this.router.navigate(['']);
  }

}
